import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

interface IRequires {
  msg: string;
  value?: string;
}
interface ILabelForm {
  label: string;
  requires?: IRequires[];
  children: ReactNode;
  required?: boolean;
}
export function LabelForm({
  label,
  requires = [],
  children,
  required = false,
}: ILabelForm) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "baseline" },
        mb: "16px",
        pb: "16px",
        borderBottom: "1px solid #DFE4E8",
      }}
    >
      <Box
        sx={{
          mr: { xs: 0, sm: "32px" },
          mb: { xs: "8px", sm: 0 },
          width: { xs: "100%", sm: "200px" },
          flexShrink: 0,
        }}
      >
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "20px",
          }}
        >
          {`${label}:${required ? "*" : ""}`}
        </Typography>
        {requires.map((item) => (
          <Typography
            key={`${item.msg}-${item.value ?? ""}`}
            sx={{ fontWeight: 400, fontSize: "12px", lineHeight: "16px" }}
          >
            {`${item.msg}${item.value ? `: ${item.value}` : ""}`}
          </Typography>
        ))}
      </Box>
      <Box
        sx={{
          flex: "1",
          width: { xs: "100%", sm: "auto" },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
